<style lang="scss" scoped>
  .product-image {
    min-height: 300px;
    background-size: cover;
    background-position: center center;
  }

  .md-tab {
    padding: 0;
  }

  .cell-image {
    width: 134px;
  }

  .cell-quantity {
    width: 120px;
  }
</style>

<template>
  <div>
    <div class="clearfix mxn2 flex" v-if="product">
      <div class="col col-4 px2">
        <div class="card sh1">
          <div class="p1" v-if="product.pictures.length > 0">
            <a :href="mainPicture.href" data-lightbox="image-1" :data-title="mainPicture.title">
              <img :src="mainPicture.href">
            </a>
            <div class="pictures clearfix mt2 mxn1 flex justify-center">
              <div class="col col-3 px1" v-for="(picture, index) in extraPictures"
                   :class="{active: index === selectedPicture}">
                <a :href="picture.href" data-lightbox="image-1" :data-title="picture.title">
                  <img :src="picture.href">
                </a>
              </div>
            </div>
          </div>
          <div class="p3">
            <div class="bold fz18 mb2">{{ product.name }}</div>
            <div v-html="product.long_description"></div>
          </div>
        </div>
      </div>
      <div class="col col-8 px2">
        <div class="bg-white rounded sh1">
          <div class="clearfix p3">
            <div class="col col-7 border-right border-light-grey pr3">
              <div class="bold fz18 mb2">Tilpass produktet</div>
              <myo-parameters :type="product.slug"
                              ref="parameters"
                              @loaded="onParametersLoaded"
                              @changed="onParametersChanged"></myo-parameters>
            </div>
            <div class="col col-5 pl3">
              <div class="bold fz18 mb2">Pris</div>
              <div class="clearfix flex">
                <div class="col col-6">
                  <div class="fz24 light mb1">kr {{ toLocale(unitPrice) }},-</div>
                  <small class="text-grey">Pr. stk.</small>
                </div>
                <div class="col col-6 right-align">
                  <div class="fz24 light mb1 text-blue">kr {{ toLocale(price) }},-</div>
                  <small class="text-grey">Totalpris inkl. MVA</small>
                </div>
              </div>
              <div>
                <myo-input type="number" v-model="quantity" class="myo-input-block my2 center"
                           :disabled="!parametersLoaded"></myo-input>
              </div>
              <div>
                <md-button class="md-raised md-primary btn-block" @click.native="buy()">Kjøp</md-button>
              </div>
            </div>
          </div>
        </div>

        <div class="card sh1 mt3" id="accessories" v-if="product.accessories.length > 0">

          <div class="bold fz18 p3 b border-bottom border-light-grey">Tilbehør</div>

          <table cellpadding="0" cellspacing="0" class="full-width mt1">
            <thead>
            <tr>
              <th class="text-grey px2 py1 left-align" colspan="2">Produkt</th>
              <th class="text-grey px2 py1 left-align">Pris</th>
              <th class="text-grey px2 py1">Antall</th>
              <th class="text-grey px2 py1">Kjøp</th>
            </tr>
            </thead>
            <tbody>
            <tr class="@bg-light-blue" v-for="(accessory, index) in product.accessories">
              <td class="p2 cell-image">
                <img class="rounded pointer" :src="getThumbnail(accessory)"
                     @click="viewProduct(accessory.id)"
                     width="100" height="100"/>
              </td>
              <td class="px2">
                <div class="fz16 mb1 text-blue pointer" @click="viewProduct(accessory.id)">{{ accessory.name }}
                </div>
                <div>
                  {{ accessory.short_description }}
                </div>
              </td>
              <td class="px2">
                <div class="fz24 light mb1 text-blue truncate">kr {{ toLocale(accessory.from_price) }},-</div>
                <small class="text-grey">Pr. stk.</small>
              </td>
              <td class="px2 cell-quantity">
                <myo-input v-model="accessory.quantity" class="myo-input-block my2 center"></myo-input>
              </td>
              <td class="px2 center">
                <md-button class="md-raised md-primary" @click.native="buyAccesory(accessory)">Kjøp</md-button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>

        <div class="card sh1 mt3" id="related" v-if="product.related.length > 0">

          <div class="bold fz18 p3 b border-bottom border-light-grey">Relaterte produkter</div>

          <table cellpadding="0" cellspacing="0" class="full-width mt1">
            <thead>
            <tr>
              <th class="text-grey px2 py1 left-align" colspan="2">Produkt</th>
              <th class="text-grey px2 py1 left-align">Pris</th>
              <th class="text-grey px2 py1">Kjøp</th>
            </tr>
            </thead>
            <tbody>
            <tr class="@bg-light-blue" v-for="(related, index) in product.related">
              <td class="p2 cell-image">
                <img class="rounded pointer" :src="getThumbnail(related)"
                     @click="viewProduct(related.id)"
                     width="100" height="100"/>
              </td>
              <td class="px2">
                <div class="fz16 mb1 text-blue pointer" @click="viewProduct(related.id)">{{ related.name }}
                </div>
                <div>
                  {{ related.short_description }}
                </div>
              </td>
              <td class="px2">
                <div class="fz24 light mb1 text-blue truncate">kr {{ toLocale(related.from_price) }},-</div>
                <small class="text-grey">Pr. stk.</small>
              </td>
              <td class="px2 center">
                <md-button class="md-raised md-primary" @click.native="viewProduct(related.id)">Kjøp</md-button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>

        <div class="card sh1 mt3" id="templates" md-label="Maler" v-if="product.templates.length > 0">

          <div class="bold fz18 p3 b border-bottom border-light-grey">Maler og manualer</div>

          <table cellpadding="0" cellspacing="0" class="full-width mt1">
            <thead>
            <tr>
              <th class="text-grey px2 py1 left-align" colspan="2">Fil</th>
              <th class="text-grey px2 py1">Last ned</th>
            </tr>
            </thead>
            <tbody>
            <tr class="@bg-light-blue" v-for="(template, index) in product.templates">
              <td class="border-bottom border-light-grey p2" style="width: 70px">
                <img src="/static/img/ui/blank-file.svg" width="50" height="50"/>
              </td>
              <td class="border-bottom border-light-grey p2">
                <a class="fz16 mb1 text-blue pointer" :href="template.href" target="_blank">{{ template.title }}</a>
                <div class="text-grey mt1">
                  {{ template.original_filename }}
                </div>
              </td>
              <td class="border-bottom border-light-grey px2 center">
                <a :href="template.href" target="_blank">
                  <md-button class="md-raised md-primary">Last ned</md-button>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiProduct from '@/js/api/product';
  import apiProductPrice from '@/js/api/productPrice';
  import apiCartItem from '@/js/api/cartItem';
  import apiCart from '@/js/api/cart';
  import hasPrices from '@/js/mixins/hasPrices';
  import hasPictures from '@/js/mixins/hasPictures';

  export default {
    mixins: [hasPrices, hasPictures],

    data() {
      return {
        product: null,
        quantity: 0,
        selectedPicture: 0,
        price: null,
        unitPrice: null,
        parametersLoaded: false,
      };
    },

    mounted() {
      // this.state.start('loading');
      this.fetch(this.$route.params.productId);
    },

    beforeRouteUpdate(to, from, next) {
      // Reset
      this.product = null;
      this.quantity = 1;
      this.price = null;
      this.unitPrice = null;
      this.parametersLoaded = false;

      this.fetch(to.params.productId);

      next();
    },

    methods: {
      fetch(id) {
        apiProduct.show(id).then(this.onFetchSuccess);
      },

      onFetchSuccess(response) {
        const product = response.data.data;

        product.accessories = _.map(product.accessories, (o) => {
          o.quantity = 1;
          return o;
        });

        product.related = _.map(product.related, (o) => {
          o.quantity = 1;
          return o;
        });

        this.product = product;
        this.fetchPrice();
        // this.state.stop('loading');
      },

      onPriceSuccess(response) {
        this.price = response.data.data.price;
        this.unitPrice = response.data.data.unit_price;
      },

      onParametersLoaded() {
        this.parametersLoaded = true;
        this.quantity = 1;
      },

      onParametersChanged() {
        this.fetchPrice();
      },

      fetchPrice() {
        if (this.quantity > 0) {
          if (this.source !== undefined) {
            this.source.cancel();
          }

          const CancelToken = axios.CancelToken;
          this.source = CancelToken.source();

          const data = {
            product_id: this.$route.params.productId,
            quantity: this.quantity,
            parameters: this.$refs.parameters.parameters,
          };

          apiProductPrice.create(data, this.source.token)
            .then(this.onPriceSuccess)
            .catch((error) => {});
        } else {
          this.price = null;
          this.unit_price = null;
        }
      },

      viewProduct(id) {
        this.$router.push({ name: 'view-product', params: { productId: id } });
      },

      buy() {
        apiCart.get().then((cart) => {
          const data = {
            cart_id: cart.id,
            product_id: this.$route.params.productId,
            quantity: this.quantity,
            parameters: this.$refs.parameters.parameters,
          };

          apiCartItem.store(data).then(() => {
            this.$router.push({ name: 'cart' });
          });
        });
      },

      buyAccesory(product) {
        apiCart.get().then((cart) => {
          const data = {
            cart_id: cart.id,
            product_id: product.id,
            quantity: product.quantity,
            parameters: [],
          };

          apiCartItem.store(data).then(() => {
            this.$router.push({ name: 'cart' });
          });
        });
      },
    },

    computed: {
      mainPicture() {
        return this.product.pictures[0];
      },

      extraPictures() {
        return this.product.pictures.slice(1);
      },
    },

    watch: {
      quantity(value) {
        this.fetchPrice();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Product.vue?33dbc98a